import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

class LanoelProductData extends HTMLElement {
  #section;
  #sequence = 0;

  connectedCallback() {
    this.#section = this.closest('.shopify-section');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#update);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#update);
    this.#sequence++;
  }

  #update = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const sequence = ++this.#sequence;
    event.promise.then(({ detail }) => {
      if (!this.isConnected || sequence !== this.#sequence || !detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const replacement = detail.html.querySelector(`lanoel-product-data[data-ln-mode="${this.dataset.lnMode}"]`);
      if (!replacement) return;
      this.hidden = replacement.hidden;
      this.dataset.productId = replacement.dataset.productId;
      this.dataset.variantId = replacement.dataset.variantId;
      morph(this, replacement, { childrenOnly: true });
    }).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[LANOEL product data]', error);
    });
  };
}

if (!customElements.get('lanoel-product-data')) customElements.define('lanoel-product-data', LanoelProductData);
